<div class="btn-container">
  <button type="button" class="btn btn-outline-secondary btn-xs text-center" (click)="this.listClick.emit()" *ngIf="!this.hideList" >
    <i class="fa fa-search has-color-aqua"></i>
  </button>
  <button type="button" class="btn btn-outline-secondary btn-xs text-center" (click)="this.viewClick.emit()"  *ngIf="!this.hideView">
    <i class="fa fa-eye has-color-aqua"></i>
  </button>
</div>
